import axios from 'axios';
import {
  RUNNING_TYPE,
  RUNNING_TYPE_MASTER,
  RUNNING_TYPE_DEVELOP,
  RUNNING_TYPE_LOCAL,
  FILE_LIST_API_S3_URL,
  FILE_LIST_API,
  API_URL,
  API_DEV_URL,
  API_LOCAL_URL,
  API_KEY,
  API_KEY_RC_TEST,
} from '../util/Const';

// ファイル一覧取得API
export const GetFileList = async () => {
  let url: string;
  let apiKey: string;
  switch (RUNNING_TYPE) {
    case RUNNING_TYPE_MASTER:
      url = `${API_URL + FILE_LIST_API}?id=${sessionStorage.getItem('id')}`;
      apiKey = API_KEY;
      break;
    case RUNNING_TYPE_DEVELOP:
      url = `${API_DEV_URL + FILE_LIST_API}?id=${sessionStorage.getItem('id')}`;
      apiKey = API_KEY_RC_TEST;
      break;
    case RUNNING_TYPE_LOCAL:
      url = `${API_LOCAL_URL + FILE_LIST_API}?id=${sessionStorage.getItem(
        'id'
      )}`;
      apiKey = API_KEY_RC_TEST;
      break;
    default:
      url = FILE_LIST_API_S3_URL;
      apiKey = API_KEY_RC_TEST;
      break;
  }

  const res = await axios
    .get(url, {
      headers: {
        'x-api-key': apiKey,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
  console.info(url);
  return res;
};

export default GetFileList;
